import React from 'react';
import { connect } from 'react-redux';
import styles from './WorkComp.module.css';
import { DBTextField, DBDropDown, DBDateField, DBDropDownPDC } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class PatientCareCenterNoteWpSubjectiveWorkComp extends React.Component {

    computePdc(stand, walk, lift) {
        let key = Object.keys(this.props.pdcLookup)
            .find(x =>
                this.props.pdcLookup[x].PXSTANDFREQ === stand
                && this.props.pdcLookup[x].PXWALKFREQ === walk
                && (this.props.pdcLookup[x].PXLIFTWEIGHT === lift || this.props.pdcLookup[x].PXLIFTWEIGHT === null)
            );

        return key ? this.props.pdcLookup[key].PXPDC : undefined;
    }

    handleCurrentChange(event) {
        let curStand = this.props.jobStand;
        let curWalk = this.props.jobWalk;
        let curLift = this.props.jobLift;

        switch (event.target.name) {
            case this.props.prefix + 'SUBWCJOBREQSTAND':
                curStand = parseInt(event.target.value);
                break;
            case this.props.prefix + 'SUBWCJOBREQWALK':
                curWalk = parseInt(event.target.value);
                break;
            case this.props.prefix + 'SUBWCJOBREQLIFT':
                curLift = parseInt(event.target.value);
                break;
            default:
                break;
        }

        let pdc = this.computePdc(curStand, curWalk, curLift);

        if (this.props.jobReqPdc !== undefined && pdc !== undefined && this.props.jobReqPdc.WPNO !== pdc) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', pdc)
        } else if (this.props.jobReqPdc !== undefined && pdc === undefined) {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC')
        } else if (this.props.jobReqPdc === undefined && pdc !== undefined) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', pdc)
        }
    }
    render() {
        return (
            <PatientCareCenterNoteSection id='subj_workComp' name='Work Comp' level={5}>
              <div className={styles.row}>
                        <label className={styles.narrow_col}>Referral Source:</label>
                        <div className={styles.leftover_col}><DBTextField
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBWCREFSOURCE'
                                />
                        </div>
               </div>

               <div className={styles.row}>
                        <label className={styles.narrow_col}>Ins. Adjuster/NCM:</label>
                        <div className={styles.leftover_col}><DBTextField
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBWCINSADJUSTER'
                                />
                        </div>
               </div>
              
               <div className={styles.row}>
                        <label className={styles.narrow_col}>Employer:</label>
                        <span className={styles.leftover_col}>{this.props.employer}</span>
                    </div>
                    <div className={styles.row} id='subj_wc_occupation'>
                        <label className={styles.narrow_col_req}>Occupation:</label>
                        <span className={styles.leftover_col}>
                            {this.props.occupations !== undefined &&
                                <DBDropDown
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBWCOCCUPATION'
                                    customOptions={this.props.occupations}
                                />
                            }
                            {this.props.occupations === undefined &&
                                <DBTextField
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBWCOCCUPATION'
                                />
                            }
                        </span>
                    </div>
                    <div className={styles.row} id='subj_wc_status'>
                        <label className={styles.narrow_col_req}>Status:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                field='EVSUBWCSTATUS'
                                masterEntity='PTMASTERWCSTATUS'
                                masterEntityKeyColumn='WSNO'
                                masterEntitySort='WSORDER'
                                masterEntityDisplay='WSNAME'
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.narrow_col}>Last Day:</label>
                        <span className={styles.leftover_col}>
                            <DBDateField
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                maxDate={new Date()}
                                field='EVSUBWCLASTDAY'
                            />
                        </span>
                    </div>

                    <PatientCareCenterNoteSection id='subj_wc_job_pdc' name='Job Required PDC Analysis' level={5} allowCollapse={false}> 
                    <div className={styles.row}>
                        <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>How much time is the patient currently able to <b>stand</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCJOBREQSTAND'}
                                isCurrent={true}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>How much time is the patient currently able to <b>walk</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCJOBREQWALK'}
                                isCurrent={true}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>How much weight is the patient currently able to <b>lift</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCJOBREQLIFT'}
                                masterEntity='PTMASTERWCPDCWEIGHT'
                                masterEntityKeyColumn='WWNO'
                                masterEntitySort='WWORDER'
                                masterEntityDisplay='WWNAME'
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>Job Required PDC:</label>
                        <span className={styles.leftover_col}>
                            {this.props.jobReqPdc ? this.props.jobReqPdc?.WPNAME : ''}
                        </span>
                    </div>
                </PatientCareCenterNoteSection> 

                <PatientCareCenterNoteSection id='subj_wc_goal_pdc' name='Goal PDC' level={5} allowCollapse={false}> 
                    <div className={styles.row}>
                        <label className={styles.wide_col_req}>PDC Level:</label>
                        <span className={styles.leftover_col}>
                        <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                field='EVSUBWCGOALPDC'
                                masterEntity='PTMASTERWCPDC'
                                masterEntityKeyColumn='WPNO'
                                masterEntitySort='WPORDER'
                                masterEntityDisplay='WPNAME'
                            />
                        </span>
                    </div>
                </PatientCareCenterNoteSection> 

            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearGoals: bindActionCreators(noteActions.clearGoals, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = state.entities.notes.PTEVAL[pk].EVEPNO;

    let employer = Object.keys(state.entities.insured)
    .filter(key => {
        return (state.entities.insured[key].epno === epno
            && state.entities.insured[key].position === 1)
    })
    .map(key => state.entities.insured[key]);
    let occupations = undefined;

    if (state.entities.admissions[epno].isMdcps === true) {
        occupations = Object.keys(state.entities.masterData.FNJOBTITLES)
            .filter(key => {
                return (state.entities.masterData.FNJOBTITLES[key].JTMDCPS === true);
            })
            .sort((a, b) => {
                return state.entities.masterData.FNJOBTITLES[a].JTNAME > state.entities.masterData.FNJOBTITLES[b].JTNAME ? 1 : -1;
            })
            .map(key => { return { id: state.entities.masterData.FNJOBTITLES[key].JTNAME, value: state.entities.masterData.FNJOBTITLES[key].JTNAME } })
    }
    return {
        noteId: noteId,
        evno: evno,
        pk,
        prefix: "EV",
        table: "PTEVAL",
        pdcLookup: state.entities.masterData.PTMASTERWCPDCXREF,
        currentPdc: state.entities.masterData.PTMASTERWCPDC[state.entities.notes.PTEVAL[pk].EVSUBWCCURRENTPDC],
        employer: employer && employer[0] ? employer[0].employerName : undefined,
        occupations: occupations,
        jobStand: state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQSTAND,
        jobWalk: state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQWALK,
        jobLift: state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQLIFT,
        jobReqPdc: state.entities.masterData.PTMASTERWCPDC[state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC],
    };
}

const connectedPatientCareCenterNoteWpSubjectiveWorkComp = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteWpSubjectiveWorkComp);
export { connectedPatientCareCenterNoteWpSubjectiveWorkComp as PatientCareCenterNoteWpSubjectiveWorkComp };

